import { Autocomplete, Stack, TextField, Typography } from '@mui/material';
import { useAuth } from 'modules/auth/hooks';
import { useLocalization } from 'localization';
import { LAST_DEPARTMENT_ID } from 'api/http';
import { DataSelect } from '../input/AutoCompleteInput';

type Props = {
  handleChange: (value: DataSelect) => void;
};

const DefaultBranchOptions = (props: Props) => {
  const { t } = useLocalization();
  const { user, userIsLoading } = useAuth();
  const { handleChange } = props;

  const branchOptions =
    user?.branches?.map(branch => ({
      label: branch.name,
      value: branch.id,
    })) ?? [];

  const currentSelectedBranchId = localStorage.getItem(LAST_DEPARTMENT_ID);
  const defaultValue = branchOptions.find(branch => branch.value === currentSelectedBranchId) ?? branchOptions?.[0];

  return (
    <Stack gap={2}>
      <Typography variant="h4">{t('common.terms.currentDepartment')}</Typography>
      <Autocomplete
        loadingText={userIsLoading}
        defaultValue={defaultValue}
        options={branchOptions}
        renderInput={params => <TextField {...params} />}
        onChange={(_, option) => {
          if (option) handleChange(option);
        }}
      />
    </Stack>
  );
};

export default DefaultBranchOptions;
